/**
 * API Services - Central Export
 * This file re-exports all domain-specific services for backward compatibility
 * New code should import directly from domain-specific service files
 * @module services/api
 */

import httpClient from '../utils/httpClient';
// Import domain-specific services
import employeeService from './employees/employeeService';
import payrollService from './payroll/payrollService';
import clientService from './clients/clientService';
import logService from './logs/logService';
import settingsService from './settings/settingsService';
import userService from './users/userService';
import invoiceService from './invoices/invoiceService';
import dashboardService from './dashboard/dashboardService';
import chatService from './chat/chatService';
import salaryHelpers from './salary/salaryHelpers';
import taskService from './tasks/taskService';
import branchService from './branches/branchService';
import organizationService from './organizations/organizationService';
import uploadService from './upload/uploadService';
import shiftService from './shifts/shiftService';

// Re-export httpClient as 'api' for backward compatibility
const api = httpClient;

// Re-export authService (already exists in separate file)
export { default as authService } from './authService';

// Export all domain services
export { employeeService };
export { payrollService };
export { clientService };
export { logService };
export { settingsService };
export { userService };
export { invoiceService };
export { dashboardService };
export { chatService };
export { salaryHelpers };
export { taskService };
export { branchService };
export { organizationService };
export { uploadService };
export { shiftService };

// Default export for backward compatibility
export default api;
